import React from 'react';
import ReferralStepper from "./ReferralStepper";
import { useAppCreateReferralContext } from '../context/AppCreateReferralProvider';
import { useNavigate, useLocation } from 'react-router-dom';
export default function CreateReferralContainer(_ref) {
  var children = _ref.children,
    isStepReferralSent = _ref.isStepReferralSent;
  var location = useLocation();
  var navigate = useNavigate();
  var _useAppCreateReferral = useAppCreateReferralContext(),
    addSelectClient = _useAppCreateReferral.state.addSelectClient;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReferralStepper, {
    className: "px-12 py-6",
    navigate: navigate,
    location: location,
    isStepReferralSent: isStepReferralSent,
    addSelectClient: addSelectClient
  }), children);
}
;
//# sourceMappingURL=CreateReferralContainer.js.map